import React, { memo } from "react";

interface IProjectIconProps {
  size?: number;
}

const ProjectIcon: React.FC<IProjectIconProps> = memo(({ size = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M13.7088 3.35714C13.7088 4.93429 11.15 6.21429 7.99456 6.21429C4.83913 6.21429 2.28027 4.93429 2.28027 3.35714C2.28027 1.78 4.83913 0.5 7.99456 0.5C11.15 0.5 13.7088 1.78 13.7088 3.35714ZM2.28027 13.6429V5.628C3.48827 6.68629 5.55342 7.35714 7.99456 7.35714C10.4357 7.35714 12.5008 6.68629 13.7088 5.628V13.6429C13.7088 15.2714 11.2528 16.5 7.99456 16.5C4.73627 16.5 2.28027 15.2714 2.28027 13.6429Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ProjectIcon };
